module.exports = __webpack_public_path__ + "3b2a53f98febb29fe79e505a963e876e.svg";